import { Box, HStack } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LeadIcon } from "enums/lead-icon.enum";
import {
  ISelectInputOptionProps,
  SelectInputOptionBase,
} from "../SelectInputOptionBase";
import { LEAD_ICON_MAP } from "constants/lead-icons";

export const LeadIconSelectOption: React.FC<ISelectInputOptionProps<
  LeadIcon
>> = ({ optionProps }) => {
  const { option, ...rest } = optionProps;

  const icon = LEAD_ICON_MAP[option.value];

  return (
    <SelectInputOptionBase option={option} {...rest}>
      <HStack spacing={2}>
        {icon && (
          <Box color={icon.color}>
            <FontAwesomeIcon icon={icon.icon} fontSize={"16px"} />
          </Box>
        )}
        <Box>{option.label}</Box>
      </HStack>
    </SelectInputOptionBase>
  );
};
